import { useCoursesStore } from '~~/stores/courses'
import { usePaymentStore } from '~~/stores/payment'

const useFetch = ({ emits, selectedVoucher }) => {
  const { getQueryStringFromObject } = useQueryString()
  const coursesStore: Record<string, any> = useCoursesStore()
  const courseDetail = computed(() => coursesStore?.state?.courseDetail)

  const paymentStore: Record<string, any> = usePaymentStore()
  const vouchersPublic = computed(() => paymentStore?.state?.vouchersPublic)
  const voucherByCode = computed(() => paymentStore?.state?.voucherByCode)

  const expandKey = ref(['1'])
  const activeVoucher = ref(selectedVoucher?.value ?? null)
  const voucherCode = ref<string>(null)

  const resetVoucher = () => {
    activeVoucher.value = null
    voucherCode.value = null
  }

  const getVoucherByCode = () => {
    if (voucherCode.value) {
      paymentStore.claimVoucherCode({
        params: getQueryStringFromObject({
          code: voucherCode.value,
          courseSerial: courseDetail.value?.data?.serial
        }),
        resolve: () => {
          activeVoucher.value = voucherByCode.value?.data
          emits('onBack', activeVoucher.value)
        }
      })
    }
  }

  return {
    getQueryStringFromObject,
    courseDetail,
    paymentStore,
    vouchersPublic,
    expandKey,
    activeVoucher,
    resetVoucher,
    voucherCode,
    getVoucherByCode
  }
}

export default useFetch
